/**
 * Inventory Store
 *
 * @since 2018-08-13
 * @author Nanhyoung.Ro <dev014>
 */

import {pcDownloadFile} from '~/utils/files'
export const state = () => ({
  apiPreFix: '/api/lr/report/viewer'
})

export const mutations = {
}
export const actions = {
  // 로그 상세 페이지 결과 조회
  async getSearchResult ({commit, state}, param) {
    let result = {}
    const apiUrl = `${state.apiPreFix}`
    try {
      result = await this.$axios.$post(apiUrl, param, {successAlert: false, loading: false})
      if (result.code === 'ok') {
        state.reportList = result.result
      } else {
        state.reportList = []
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      state.reportList = []
      return result
    }
  },
  async downloadSave ({commit, state}, filePath) {
    const result = {}
    const apiUrl = `${state.apiPreFix}/download/${filePath.path}`
    try {
      const res = await this.$axios.$file(apiUrl, void 0, {
        responseType: 'blob',
        method: 'POST',
        successAlert: false
      })

      const fileP = filePath.path.split('/')
      const fileName = fileP[fileP.length - 1]
      pcDownloadFile(res.data, fileName)

      result.code = 'ok'
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },
  async downloadZipSave ({commit, state}, param) {
    const result = {}
    const apiUrl = `${state.apiPreFix}/download/zip`
    try {
      const res = await this.$axios.post(apiUrl, param, {
        responseType: 'blob',
        method: 'POST',
        successAlert: false
      })

      const contentDispos = res.headers['content-disposition']
      const headerFileInfo = contentDispos.split(';')
      const findTxt = (contentDispos.indexOf('filename*') > -1) ? 'filename*=' : 'filename='
      const findIdx = _.findIndex(headerFileInfo, (d) => { return d.indexOf(findTxt) > -1 })
      let fileName = headerFileInfo[findIdx].split('=')[1]
      fileName = (fileName.indexOf('UTF-8') > -1) ? fileName.substring(7, fileName.length) : fileName
      pcDownloadFile(res.data, decodeURI(fileName))

      result.code = 'ok'
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },
  // 검색 중지
  async removeReport ({commit, state}, param) {
    let result = {}
    const apiUrl = `${state.apiPreFix}`
    try {
      result = await this.$axios.$delete(`${apiUrl}`, {data: param, loading: false})
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  }
}

export const getters = {}
export const strict = false
